/**
 * Shared helpers for rendering asset detail views.
 * Extracted from home.js so browse.js can reuse them.
 */

export function escapeHtml(str) {
  const div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

export function escapeAttr(str) {
  return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

export function humanizeKey(key) {
  return key
    .replace(/^_snipeit_/, '')
    .replace(/_/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function looksLikeTechnicalValue(str) {
  if (/^([0-9A-Fa-f]{2}[:-]){5}[0-9A-Fa-f]{2}$/.test(str)) return true;
  if (/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(str)) return true;
  if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(str)) return true;
  return false;
}

export function statusClass(statusType) {
  return statusType === 'deployable' ? 'deployable'
    : statusType === 'pending' ? 'pending'
    : statusType === 'archived' ? 'archived' : '';
}

export function formatFieldValue(key, val) {
  if (val === null || val === undefined || val === '') return null;

  if (typeof val === 'object' && val !== null && !Array.isArray(val)) {
    if (key === 'assigned_to') {
      const name = val.name || val.username || '\u2014';
      const type = val.type || '';
      let extra = '';
      if (type === 'user' && val.username) {
        extra = `<span style="display:block; font-size:0.7rem; color:var(--color-text-placeholder); margin-top:1px;">@${escapeHtml(val.username)}${val.employee_num ? ' \u2022 ' + escapeHtml(val.employee_num) : ''}</span>`;
      }
      return escapeHtml(String(name)) + extra;
    }
    if (key === 'status_label' && val.name) {
      const cls = statusClass(val.status_type || '');
      return `<span class="status-tag ${cls}">${escapeHtml(val.name)}</span>`;
    }
    if ('name' in val && val.name) return escapeHtml(String(val.name));
    if ('datetime' in val && val.formatted) return escapeHtml(String(val.formatted));
    if ('datetime' in val && val.datetime) return `<span class="mono">${escapeHtml(String(val.datetime))}</span>`;
    const str = JSON.stringify(val);
    if (str === '{}' || str === '[]') return null;
    return `<span class="mono" style="font-size:0.75rem; word-break:break-all;">${escapeHtml(str)}</span>`;
  }

  if (typeof val === 'boolean') {
    return val ? '<span class="status-tag deployable">Yes</span>' : '<span class="status-tag">No</span>';
  }
  if (typeof val === 'number') return escapeHtml(String(val));

  const str = String(val);
  if (str.trim() === '') return null;
  if (key === 'image' && (str.startsWith('http://') || str.startsWith('https://'))) {
    return `<img src="${escapeAttr(str)}" alt="${escapeAttr(key)}" style="max-width:120px; max-height:80px; border-radius:4px; border:1px solid var(--color-border);" loading="lazy" />`;
  }
  if (looksLikeTechnicalValue(str)) return `<span class="mono">${escapeHtml(str)}</span>`;
  return escapeHtml(str);
}
